import { RootState } from '../../../store/reducer'
import { TradingPlanRequestParams } from '../types'

const selectTradingPlanState = (state: RootState) => state.tradingPlan

export const selectPlannedTrades = (state: RootState) => selectTradingPlanState(state).plannedTrades

export const selectPagination = (state: RootState) => selectTradingPlanState(state).pagination

export const selectLoading = (state: RootState) => selectTradingPlanState(state).loading

export const selectSaving = (state: RootState) => selectTradingPlanState(state).saving

export const selectDeleting = (state: RootState) => selectTradingPlanState(state).deleting

export const selectReports = (state: RootState) => selectTradingPlanState(state).reports

export const selectReportsLoading = (state: RootState) =>
  selectTradingPlanState(state).reportsLoading

export const selectReportsError = (state: RootState) => selectTradingPlanState(state).reportsError

export const selectFetchParams = (state: RootState): TradingPlanRequestParams | null => {
  const { pagination } = selectTradingPlanState(state)
  const accountId = state.userAccounts.currentAccount?.id

  if (!accountId) return null

  return {
    page: pagination.page,
    perPage: pagination.perPage,
    order: pagination.order,
    orderBy: pagination.orderBy,
    accountId,
    columns: pagination.columns,
    search: pagination.search,
  }
}

const selectors = {
  plannedTrades: selectPlannedTrades,
  pagination: selectPagination,
  loading: selectLoading,
  saving: selectSaving,
  deleting: selectDeleting,
  reports: selectReports,
  reportsLoading: selectReportsLoading,
  reportsError: selectReportsError,
  fetchParams: selectFetchParams,
}

export default selectors
